export const COIN = "SLSD";
export const GT = "PSY";
export const LP = "UNI LP";
// export const LP = "ETH/SLSD LP";
